import React from 'react';
import { SketchPicker } from "react-color";
import '../Task Components.css';

const ColorPicker = ({ color, displayColorPicker, onColorChange, onColorClick }) => {
    return (
      <div className='color'>
        <p>{color}</p>
        <div
          style={{ height: '18px', width: '18px', background: color, cursor: 'pointer',marginRight:'5px', border: '0.5px solid #757EA5', }}
          onClick={onColorClick}
        ></div>
        {displayColorPicker ? (
          <div className="color-picker">
            <SketchPicker color={color} onChange={onColorChange} />
          </div>
        ) : null}
      </div>
    );
  };

export default ColorPicker